import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { EnableEscCloseDirective, UiButtonComponent } from '@ui';
import { DataForm, GraphModes } from '../../flow-chart.model';
import { TagFilterComponent } from 'src/app/pages/database/pages/tags/components/tag-filter/tag-filter.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface EditWorkflowDialogData {
  name?: string;
  tags?: string[];
  graphMode: GraphModes;
}

@Component({
  selector: 'app-edit-workflow-dialog',
  imports: [
    MatDialogClose,
    ReactiveFormsModule,
    TagFilterComponent,
    UiButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './edit-workflow-dialog.component.html',
  styleUrl: './edit-workflow-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective],
})
export class EditWorkflowDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<EditWorkflowDialogComponent>>(MatDialogRef);
  private fb = inject(FormBuilder);
  public data = inject<EditWorkflowDialogData>(MAT_DIALOG_DATA);

  public dataForm: FormGroup<DataForm> = this.fb.group({
    name: ['', Validators.required],
    tags: [null],
  });

  public ngOnInit(): void {
    this.dataForm.patchValue({
      name: this.data?.name,
      tags: this.data?.tags,
    });

    if (this.data?.graphMode === GraphModes.Publish) {
      this.dataForm.disable();
    }
  }

  public close() {
    this.dialogRef.close();
  }

  public save() {
    this.dialogRef.close(this.dataForm.getRawValue())
  }
}
